<template>
  <Card>
    <AjaxForm route="admin/MarketProductAttr/Add">
      <CustomInput type="text" name="title" placeholder="عنوان را انتخاب کنید" label="عنوان ویژگی"></CustomInput>
      <button class="btn btn-info my-2 mx-auto px-5 d-block" type="submit">ثبت ویژگی</button>
    </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
export default {
  name: "MarketProductAttrAdd",
  components: {CustomInput, AjaxForm, Card},
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ثبت ویژگی محصولات بازار');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>